import React from 'react';
import { createSafeMarkdown } from '../../utils/safeMarkdown';
import { formatLocalDateValue } from '../../utils/localDateTime';

const markdown = createSafeMarkdown();

const formatLabel = (value: string): string => value
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/^./, character => character.toUpperCase());

export const normalizeAnalysisText = (value: unknown): string => {
    if (value === null || value === undefined)
        return '';
    const date = formatLocalDateValue(value);
    if (date)
        return date;
    if (typeof value === 'string')
        return value.replace(/\\n/g, '\n').trim();
    if (typeof value !== 'object')
        return String(value);
    if (Array.isArray(value))
        return value
            .map(normalizeAnalysisText)
            .filter(Boolean)
            .map(item => `- ${item.replace(/\n/g, '\n  ')}`)
            .join('\n');

    return Object.entries(value)
        .map(([key, entry]) => ({ label: formatLabel(key), content: normalizeAnalysisText(entry) }))
        .filter(entry => entry.content)
        .map(entry => entry.content.includes('\n')
            ? `- **${entry.label}:**\n  ${entry.content.replace(/\n/g, '\n  ')}`
            : `- **${entry.label}:** ${entry.content}`)
        .join('\n');
};

interface AnalysisMarkdownProps {
    value: unknown;
    className?: string;
}

const AnalysisMarkdown: React.FC<AnalysisMarkdownProps> = ({ value, className = '' }) => {
    const content = normalizeAnalysisText(value);
    if (!content)
        return null;

    return (
        <div
            className={`prose prose-sm max-w-none ${className}`}
            dangerouslySetInnerHTML={{ __html: markdown.render(content) }}
        />
    );
};

export default AnalysisMarkdown;
